import { is } from 'immutable';
import { createSelectorCreator, defaultMemoize } from 'reselect';

import { State } from 'flow/types/State';

/* Compares what the result function is handed by value rather than by
 * reference. Wrapped around a selector that rebuilds a collection, it hands
 * back the collection it returned last time whenever the contents are equal,
 * so consumers that compare by identity - useSelector, memo, useMemo deps -
 * stand still. */
export const createImmutableSelector = createSelectorCreator(
    defaultMemoize,
    is,
);

/* A store update can write equal data again. The selector then hands back the
 * result it had, so a list keeps its rows. */
export const keepWhileEqual = <Result, Props = string>(
    select: (state: State, props: Props, ...args: never[]) => Result,
) => createImmutableSelector([select], (result: Result) => result);
